<template>
  <div>
    <div class="campaign-create-condition">
      <Panel>
        <FormItemLabel v-if="currentGroup.allowWebInstantwin" class="account-info-label" label="キャンペーンタイプ" />
        <div v-if="currentGroup.allowWebInstantwin" class="campaign-action-type">
          <el-select
            :value="form.campaign_type"
            @change="changeCampaignType"
            :disabled="mode === 'edit' || mode === 'copy'"
          >
            <el-option
              v-for="(option, index) in campaign_type_options"
              :key="index"
              :value="option.value"
              :label="option.label"
              :disabled="is_condition_disabled"
            />
          </el-select>
        </div>
        <div v-if="is_web_instantwin_period_error" class="title-input-error">
          X APIの仕様変更により、{{ ntt_aaa_switchover_date_text }}以降を含む期間ではX
          WEBインスタントウィンを開催できません。
          <br />
          キャンペーン期間を変更するか、キャンペーンタイプを変更してください。
        </div>
        <div v-if="is_keyword_campaign && currentGroup.allowWebInstantwin" class="campaign-action-type mb-x2">
          <div class="condition-description">X上で応募が完結する、後日抽選のキャンペーンです。</div>
        </div>
        <div
          v-else-if="is_web_instantwin_campaign && currentGroup.allowWebInstantwin && !is_web_instantwin_period_error"
          class="campaign-action-type mb-x2"
        >
          <div class="condition-description">
            キャンペーン応募後、WEBページと連携することですぐに当選結果がわかる仕組みです。
            <br />
            応募条件を満たしている場合のみ、抽選が可能です。
            <br />
            キャンペーン応募ページが必要になります。
          </div>
        </div>

        <FormItemLabel class="account-info-label" label="応募条件" />
        <div class="campaign-action-type" :class="{ 'web-instantwin-action-type': is_web_instantwin_campaign }">
          <el-select :value="application_type" @change="changeApplicationType" :disabled="is_condition_disabled">
            <el-option
              v-for="(option, index) in application_type_options"
              :key="index"
              :value="option.value"
              :label="option.label"
            />
          </el-select>
        </div>

        <div v-if="is_retweet_campaign" class="campaign-action-type">
          <div>
            <el-radio
              v-model="retweet_action_type"
              :disabled="is_condition_disabled"
              label="retweet"
              border
              @change="changeActionType"
            >
              公式リポスト
            </el-radio>
            <el-radio
              v-model="retweet_action_type"
              :disabled="is_condition_disabled"
              label="quote_tweet"
              border
              @change="changeActionType"
            >
              引用
            </el-radio>
            <el-radio
              v-model="retweet_action_type"
              :disabled="is_condition_disabled"
              label="retweet_and_quote_tweet"
              border
              @change="changeActionType"
            >
              全て
            </el-radio>
          </div>
          <div v-if="is_retweet_action" class="condition-description">
            特定キーワードを含む実施アカウントのポストをリポスト
          </div>
          <div v-if="is_quote_tweet_action" class="condition-description">
            特定キーワードを含む実施アカウントのポストを引用
          </div>
          <div v-if="is_retweet_and_quote_tweet_action" class="condition-description">
            特定キーワードを含む実施アカウントのポストをリポストまたは引用
          </div>
          <div v-if="is_retweet_action" class="condition-image">
            <img src="@/client/assets/images/twitter_condition_retweet.png" />
          </div>
          <div v-if="is_quote_tweet_action" class="condition-image">
            <img src="@/client/assets/images/twitter_condition_quote_tweet.png" />
          </div>
          <div v-if="is_retweet_and_quote_tweet_action" class="condition-image">
            <img src="@/client/assets/images/twitter_condition_retweet_and_quote_tweet.png" />
          </div>
        </div>

        <div v-if="is_tweet_campaign" class="campaign-action-type">
          <div>
            <el-radio
              v-model="tweet_action_type"
              :disabled="is_condition_disabled"
              label="tweet"
              border
              @change="changeActionType"
            >
              通常
            </el-radio>
            <el-radio
              v-model="tweet_action_type"
              :disabled="is_condition_disabled"
              label="tweet_media"
              border
              @change="changeActionType"
            >
              画像または動画
            </el-radio>
          </div>

          <div v-if="is_tweet_action" class="condition-sub-description">特定キーワードが含まれるポスト</div>
          <div v-if="is_tweet_media_action" class="condition-sub-description">
            特定キーワードと画像または動画を含むポスト
          </div>

          <div v-if="is_tweet_action" class="condition-image">
            <img src="@/client/assets/images/twitter_condition_tweet.png" />
          </div>
          <div v-if="is_tweet_media_action" class="condition-image">
            <img src="@/client/assets/images/twitter_condition_tweet_media.png" />
          </div>
        </div>

        <div v-if="is_mention_campaign" class="campaign-action-type">
          <div class="condition-description">実施アカウントへのメンションと特定キーワードを含むポスト</div>
          <div class="condition-image">
            <img src="@/client/assets/images/twitter_condition_mention.png" />
          </div>
        </div>
        <Message v-if="is_long_post_notice_target" type="warning" class="campaign-action-type">
          キャンペーンポストに入れるキーワードの位置にご注意ください。
          <Tips class="condition-tips">
            長文ポスト時にキーワードが省略されてしまうと、応募収集が正しく行なわれません。
            <br />
            詳細は<a href="https://help-atelu.comnico.jp/about-long-tweets" target="_blank" rel="noopener noreferrer"
              >こちら</a
            >をご覧ください。
          </Tips>
        </Message>
        <Message v-if="is_url_setting_notice_target" type="warning" class="campaign-action-type">
          このキャンペーンは応募収集URLの設定が必要です。
          <Tips class="condition-tips">
            キャンペーン開始後、対象のキャンペーンポストのURLを設定してください。
            <br />
            設定されていない場合は応募が収集されません。詳しくは<a
              href="https://help-atelu.comnico.jp/set-campaign-post-url"
              target="_blank"
              rel="noopener noreferrer"
              >こちら</a
            >をご確認ください。
          </Tips>
        </Message>
      </Panel>
    </div>

    <div v-if="!is_keyword_input_hidden" class="campaign-create-condition">
      <Panel>
        <div class="condition-item">
          <FormItemLabel label="以下のキャンペーンキーワード全てを含む" required />
          <div class="condition-description">キャンペーンを判別するためのキーワードを入力してください。</div>
        </div>
        <div class="condition-keywords">
          <Tags :value="and_keywords" :editable="!is_condition_disabled" :max-length="120" @input="changeAndKeywords" />
        </div>
        <div v-if="!is_web_instantwin_campaign" class="condition-item">
          <FormItemLabel label="以下のキャンペーンキーワードいずれかを含む" optional />
          <div class="condition-description">
            #catと#dogを設定した場合: #catと#dogのどちらか(または両方)を含むポストが応募対象になります。
          </div>
        </div>
        <div v-if="!is_web_instantwin_campaign" class="condition-keywords">
          <Tags :value="or_keywords" :editable="!is_condition_disabled" :max-length="120" @input="changeOrKeywords" />
        </div>
        <div v-if="combinations.length && !is_web_instantwin_campaign" class="campaign-create-condition">
          <Panel>
            <div class="description-combination">以下の組み合わせの投稿が応募対象となります。</div>
            <div
              v-for="(combination_keywords, index) in combinations"
              :key="index"
              class="condition-combination-keyword"
            >
              <div class="condition-combination-index">{{ index + 1 }}</div>
              <Tags :value="combination_keywords" :editable="false" />
            </div>
          </Panel>
        </div>
        <div v-if="!is_web_instantwin_campaign" class="condition-description">
          <div class="description-danger">応募の振り分けについて</div>
          <div v-if="is_quote_tweet_action || is_retweet_and_quote_tweet_action">
            応募者のコメント内容によって応募の振り分けをする場合、キャンペーン作成後に応募グループを追加する必要があります。
          </div>
          <div v-else>応募の振り分けをする場合、キャンペーン作成後に応募グループを追加する必要があります。</div>
        </div>
      </Panel>
    </div>

    <div v-if="is_web_instantwin_campaign" class="campaign-create-condition">
      <Panel class="panel-section">
        <FormItemLabel label="キャンペーン応募ページ" />
        <div>
          <div class="label mb-x1">
            <span>表示モード</span>
          </div>
          <el-select :value="layout_type" class="web-instanwin-page-select" @change="setLayoutType">
            <el-option label="標準レイアウト" value="basic" />
            <el-option label="カスタムレイアウト" value="custom" />
          </el-select>
        </div>
        <template v-if="is_custom_layout">
          <div>
            <div class="label mb-x1 webiw-label-row">
              <span>全体背景色</span>
              <el-tooltip placement="top">
                <div slot="content">応募画面全体の背景色を設定できます</div>
                <i class="mdi mdi-help-circle"></i>
              </el-tooltip>
              <span class="badge badge-danger">必須</span>
            </div>
            <div class="logo-color-label">
              <ColorPicker
                :value="custom_layout.body_background_color"
                :showHex="webiw_background_color_show_hex"
                :disabled="is_condition_disabled"
                @input="setBodyBackgroundColor"
              />
            </div>
          </div>
        </template>
      </Panel>
    </div>

    <div v-if="is_web_instantwin_campaign && is_basic_layout" class="campaign-create-condition">
      <Panel class="panel-section">
        <div>
          <div class="label mb-x1 webiw-label-row">
            <span>ページタイトル</span>
            <span class="badge badge-danger">必須</span>
          </div>

          <el-input
            :class="{ 'webiw-input-error-field': is_title_empty || is_title_max_length }"
            :maxlength="200"
            type="text"
            :value="form.page_title"
            tabindex="1"
            placeholder="ページタイトル"
            @input="setPageTitle"
            @blur="change('page_title')"
          />
        </div>
        <div v-if="is_title_empty" class="title-input-error">テキストを入力してください。</div>
        <div v-if="is_title_max_length" class="title-input-error">テキストタイトルは50文字以下に設定してください。</div>
        <div>
          <div class="label webiw-label-row">
            <span>メイン画像</span>
            <el-tooltip placement="top">
              <div slot="content">
                応募ページに表示されるほか、 URLをポストした際にサムネイル画像として表示されます。<br />
                後から編集できますが、編集前にポストしたURLのサムネイルは7日間保持され、更新までに時間がかかります。
              </div>
              <i class="mdi mdi-help-circle"></i>
            </el-tooltip>
            <span class="badge badge-danger">必須</span>
          </div>
          <ImageUpload
            :image-url="page_main_image_url"
            :image-origin-name="page_main_image_origin_name"
            :is-loading="upload_media_type_loading === 'main'"
            @remove-media="removeMedia"
            @file-change="handleFileChange"
          />
        </div>
        <div>
          <div class="label mb-x1 webiw-label-row">
            <span>ページテキスト</span>
            <span class="badge badge-danger">必須</span>
          </div>

          <EditableComponent
            id="text"
            class="body-textarea"
            :error="is_page_text_empty"
            :value="form.page_text"
            placeholder="内容を入力"
            @input="setPageText"
            @blur="change('page_text')"
          />
        </div>
        <div v-if="is_page_text_empty" class="title-input-error">テキストを入力してください。</div>
        <div>
          <div class="label mb-x1 webiw-label-row">
            <span>規約</span>
            <span class="badge badge-danger">必須</span>
          </div>
          <EditableComponent
            id="text"
            class="body-textarea"
            :error="is_page_rules_empty"
            :value="form.page_rules"
            placeholder="内容を入力"
            @input="setPageRules"
            @blur="change('page_rules')"
          />
        </div>
        <div v-if="is_page_rules_empty" class="title-input-error">テキストを入力してください。</div>
        <div v-if="is_web_instantwin_campaign" class="campaign-create-condition">
          <div class="condition-item auth-error-guide-row">
            <div class="auth-error-guide-label">
              <span>ログインエラー時の対応</span>
              <el-tooltip placement="top">
                <div slot="content">
                  ログインエラーの対処法を画像で表示します。<br />
                  OFFにするとテキスト表示に切り替わります。
                </div>
                <i class="mdi mdi-help-circle"></i>
              </el-tooltip>
            </div>
            <el-switch
              v-model="is_browser_guide_enabled"
              :active-text="'画像で説明する' | translate"
              @change="changeIsBrowserGuideEnabled"
            />
          </div>
          <div v-if="is_browser_guide_enabled" class="auth-error-guide-preview">
            <div class="label webiw-label-row">
              <span>{{ '認証エラーガイドプレビュー' | translate }}</span>
            </div>
            <div class="media-preview auth-error-guide-preview-frame">
              <img
                v-if="!auth_error_guide_image_load_failed"
                :src="auth_error_guide_image_src"
                :alt="'認証エラーガイド' | translate"
                class="auth-error-guide-preview-image"
                @error="auth_error_guide_image_load_failed = true"
              />
              <div v-else class="auth-error-guide-fallback">
                {{ '画像の読み込みに失敗しました。' | translate }}
              </div>
            </div>
          </div>
        </div>
      </Panel>
    </div>

    <div v-if="is_web_instantwin_campaign && is_custom_layout" class="campaign-create-condition">
      <Panel class="panel-section">
        <div class="condition-item footer-label">
          <FormItemLabel label="ヘッダー" />
          <el-tooltip placement="top">
            <div slot="content">応募、抽選中、当落選ページそれぞれに表示されるヘッダーです。</div>
            <i class="mdi mdi-help-circle"></i>
          </el-tooltip>
        </div>
        <div>
          <div class="label mb-x1 webiw-label-row">
            <span>ロゴ画像</span>
            <el-tooltip placement="top">
              <div slot="content">アップロード可能最大サイズ: 画像5MBです。</div>
              <i class="mdi mdi-help-circle"></i>
            </el-tooltip>
          </div>
          <ImageUpload
            :image-url="custom_layout.logo_image_url || null"
            :image-origin-name="custom_layout.logo_image_origin_name || null"
            :is-loading="upload_media_type_loading === 'logo'"
            @remove-media="removeLogoMedia"
            @file-change="handleLogoFileChange"
          />
        </div>
        <div>
          <div class="label mb-x1 webiw-label-row">
            <span>リンクURL</span>
            <el-tooltip placement="top">
              <div slot="content">ロゴ画像をクリックしたときのURLを設定できます。</div>
              <i class="mdi mdi-help-circle"></i>
            </el-tooltip>
          </div>
          <el-input
            :class="{ 'webiw-input-error-field': is_logo_url_invalid }"
            type="text"
            :value="custom_layout.logo_url"
            placeholder="https://"
            @input="setLogoUrl"
          />
        </div>
        <div v-if="is_logo_url_invalid" class="title-input-error">URLはhttp(s)で始まる必要があります。</div>
        <div>
          <div class="label mb-x1">
            <span>ヘッダーの高さ（PC）</span>
          </div>
          <el-input
            :value="logo_header_pc_height_input"
            :maxlength="3"
            size="small"
            placeholder="64px"
            :disabled="is_condition_disabled"
            @input="setLogoHeaderPcHeight"
          >
            <span slot="suffix" class="webiw-px-label">px</span>
          </el-input>
        </div>
        <div>
          <div class="label mb-x1">
            <span>ヘッダーの高さ（SP）</span>
          </div>
          <el-input
            :value="logo_header_sp_height_input"
            :maxlength="3"
            size="small"
            placeholder="64px"
            :disabled="is_condition_disabled"
            @input="setLogoHeaderSpHeight"
          >
            <span slot="suffix" class="webiw-px-label">px</span>
          </el-input>
        </div>
        <div>
          <div class="label mb-x1">
            <span>色の設定</span>
          </div>
          <el-switch :value="is_logo_color_enabled" :disabled="is_condition_disabled" @change="toggleLogoColor" />
        </div>
        <div v-if="is_logo_color_enabled">
          <div class="label mb-x1">
            <span>背景色</span>
          </div>
          <div class="logo-color-label">
            <ColorPicker
              :value="custom_layout.logo_background_color"
              :showHex="webiw_background_color_show_hex"
              :disabled="is_condition_disabled"
              @input="setLogoBackgroundColor"
            />
          </div>
        </div>
      </Panel>
    </div>

    <div v-if="is_web_instantwin_campaign && is_custom_layout" class="campaign-create-condition web-instanwin-page">
      <Panel class="panel-section">
        <div class="condition-item footer-label">
          <FormItemLabel label="フッター" />
          <el-tooltip placement="top">
            <div slot="content">応募、抽選中、当落選ページそれぞれに表示されるフッターです。</div>
            <i class="mdi mdi-help-circle"></i>
          </el-tooltip>
        </div>
        <div>
          <div class="label mb-x1 webiw-label-row">
            <span>フッタータイトル</span>
          </div>
          <el-input
            :maxlength="200"
            type="text"
            :value="custom_layout.footer_title"
            placeholder="©comnico.inc"
            @input="setFooterTitle"
          />
        </div>
        <div>
          <div class="label mb-x1 webiw-label-row">
            <span>フッターテキスト</span>
          </div>
          <div class="logo-color-label">
            <ColorPicker
              :value="custom_layout.footer_text"
              :showHex="webiw_background_color_show_hex"
              :disabled="is_condition_disabled"
              @input="setFooterTextColor"
            />
          </div>
        </div>
        <div>
          <div class="label mb-x1">
            <span>色の設定</span>
          </div>
          <el-switch :value="is_footer_color_enabled" :disabled="is_condition_disabled" @change="toggleFooterColor" />
        </div>
        <div v-if="is_footer_color_enabled">
          <div class="label mb-x1">
            <span>背景色</span>
          </div>
          <div class="logo-color-label">
            <ColorPicker
              :value="footer_background_color_display"
              :showHex="webiw_background_color_show_hex"
              :disabled="is_condition_disabled"
              @input="setFooterBackgroundColor"
            />
          </div>
        </div>
      </Panel>
    </div>

    <div v-if="is_web_instantwin_campaign && is_custom_layout" class="campaign-create-condition web-instanwin-page">
      <Panel class="panel-section">
        <SectionList
          :sections="custom_sections"
          :showHex="webiw_background_color_show_hex"
          :body-background-color="custom_layout.body_background_color"
          @update="updateCustomSections"
          @media-change="handleSectionMediaChange"
          @media-remove="handleSectionMediaRemove"
        />
      </Panel>
    </div>

    <div v-if="!is_web_instantwin_campaign" class="campaign-create-condition">
      <Panel class="panel-section">
        <div v-if="is_tweet_action || is_tweet_media_action" class="condition-item">
          <el-switch
            v-model="is_include_mention"
            :disabled="is_condition_disabled"
            active-text="メンションも応募対象に含める"
            @change="changeIsIncludeMention"
          />
          <div class="condition-description">
            OFFにするとメンションは除外されます。
            <br />
            <span v-if="is_tweet_media_action">ONにするとメディアなし投稿も応募される場合があります。</span>
          </div>
        </div>
        <div v-if="is_tweet_action || is_tweet_media_action || is_mention_campaign" class="condition-item">
          <el-switch
            v-model="is_include_reply"
            :disabled="is_condition_disabled"
            active-text="返信も応募対象に含める"
            @change="changeIsIncludeReply"
          />
          <div class="condition-description">OFFにするとポストに対する返信は除外されます。</div>
        </div>
        <div class="condition-item">
          <el-switch
            v-model="is_keyword_judgment"
            :disabled="is_condition_disabled"
            active-text="ポジティブまたはネガティブなアカウントを判定する"
            @change="changeIsKeywordJudgment"
          />
        </div>
        <div v-if="is_keyword_judgment" class="campaign-create-condition">
          <Panel class="panel-section">
            <div class="condition-item">
              <FormItemLabel label="ポジティブキーワード" />
              <div class="condition-description">
                登録したキーワードのいずれかが自己紹介に含まれる場合、ポジティブアカウントとして判定されます。
              </div>
              <div class="condition-keywords">
                <Tags
                  :value="positive_keyword"
                  type="keyword"
                  :editable="!is_condition_disabled"
                  :max-length="200"
                  @input="changePositiveKeywords"
                />
              </div>
            </div>
            <div class="condition-item">
              <FormItemLabel label="ネガティブキーワード" />
              <div class="condition-description">
                登録したキーワードのいずれかが自己紹介に含まれる場合、ネガティブアカウントとして判定されます。
              </div>
              <div class="condition-keywords">
                <Tags
                  :value="negative_keyword"
                  type="keyword"
                  :editable="!is_condition_disabled"
                  :max-length="200"
                  @input="changeNegativeKeywords"
                />
              </div>
            </div>
          </Panel>
        </div>
        <Tips class="condition-tips">
          キーワード判定セットを登録すると、この画面でのポジティブ・ネガティブキーワードの入力が省略できます。
          <br />
          [グループ設定 > 自己紹介キーワード判定] で登録できます。
        </Tips>
      </Panel>
    </div>

    <div v-if="is_web_instantwin_campaign && is_mention_campaign" class="campaign-create-condition">
      <Panel class="panel-section">
        <div class="condition-item">
          <el-switch
            v-model="is_include_reply"
            :disabled="is_condition_disabled"
            active-text="返信も応募対象に含める"
            @change="changeIsIncludeReply"
          />
          <div class="condition-description">OFFにするとポストに対する返信は除外されます。</div>
        </div>
      </Panel>
    </div>

    <div v-if="is_web_instantwin_campaign && is_custom_layout" class="campaign-create-condition">
      <Panel class="panel-section">
        <FormItemLabel label="OGP設定" />
        <div>
          <div class="label mb-x1 webiw-label-row">
            <span>OGPタイトル</span>
            <span class="badge badge-danger">必須</span>
          </div>
          <el-input
            :class="{ 'webiw-input-error-field': is_ogp_title_empty }"
            :maxlength="200"
            type="text"
            :value="custom_layout.ogp_title"
            placeholder="OGPタイトル"
            @input="setOgpTitle"
            @blur="change('ogp_title')"
          />
        </div>
        <div v-if="is_ogp_title_empty" class="title-input-error">テキストを入力してください。</div>
        <div>
          <div class="label mb-x1 webiw-label-row">
            <span>OGP画像</span>
            <el-tooltip placement="top">
              <div slot="content">
                URLをポストした際にOGP画像として表示されます。<br />
                後から編集できますが、編集前にポストしたURLのOGPは7日間保持され、更新までに時間がかかります。
              </div>
              <i class="mdi mdi-help-circle"></i>
            </el-tooltip>
            <span class="badge badge-danger">必須</span>
          </div>
          <ImageUpload
            :image-url="custom_layout.ogp_main_image_url || null"
            :image-origin-name="custom_layout.ogp_main_image_origin_name || null"
            :is-loading="upload_media_type_loading === 'ogp'"
            @remove-media="removeOgpMedia"
            @file-change="handleOgpFileChange"
          />
        </div>
      </Panel>
    </div>

    <div v-if="is_web_instantwin_campaign" class="campaign-create-condition">
      <Panel class="panel-section">
        <div class="condition-item">
          <FormItemLabel label="応募者フィルタ" />
        </div>
        <div class="condition-item">
          <el-switch
            v-model="exclude_unfollowed"
            tabindex="14"
            :active-text="'実施アカウントをフォローしていない場合、落選にする' | translate"
            @change="changeExcludeUnfollowed"
          />
        </div>
        <div class="condition-item">
          <el-switch
            v-model="exclude_hunter_account"
            tabindex="15"
            :active-text="'懸賞アカウントの場合、落選にする' | translate"
            @change="changeExcludeHunterAccount"
          />
          <el-tooltip placement="top">
            <div slot="content">
              {{ '懸賞が主目的のアカウントを自動判定し、該当する場合は落選とします。' | translate }}
            </div>
            <i class="mdi mdi-help-circle"></i>
          </el-tooltip>
        </div>
        <div class="condition-item">
          <el-switch
            v-model="exclude_account_create_date_within_period"
            tabindex="16"
            :active-text="'アカウント開設日がキャンペーン期間内の場合、落選にする' | translate"
            @change="changeExcludeAccountCreateDateWithinPeriod"
          />
        </div>

        <div class="condition-item">
          <el-switch
            v-model="exclude_default_profile_image"
            tabindex="17"
            :active-text="'プロフィール画像が初期状態の場合、落選にする' | translate"
            @change="changeExcludeDefaultProfileImage"
          />
        </div>

        <div class="condition-item">
          <el-switch
            v-model="exclude_no_description"
            tabindex="18"
            :active-text="'自己紹介が未入力の場合、落選にする' | translate"
            @change="changeExcludeNoDescription"
          />
        </div>

        <div class="condition-item">
          <div class="label">{{ 'フォロワー数が指定値未満の場合、落選にする(0=制限なし)' | translate }}</div>
          <el-input-number
            controls-position="right"
            :min="0"
            v-model="min_followers"
            tabindex="19"
            @change="onChangeMinFollowers"
          />
        </div>

        <div class="condition-item">
          <div class="label">{{ 'ポスト数が指定値未満の場合、落選にする(0=制限なし)' | translate }}</div>
          <el-input-number
            controls-position="right"
            :min="0"
            v-model="min_tweets"
            tabindex="20"
            @change="onChangeMinTweets"
          />
        </div>

        <div class="condition-item">
          <div class="label">
            {{ '自己紹介に次のキーワードを含む場合、落選にする(「,」区切りで一括入力可)' | translate }}
          </div>
          <div class="input">
            <tag-input
              :tags="form.exclude_description_keyword"
              :add-tag-text="'キーワード追加' | translate"
              :onChange="onChangeExcludeDescriptionKeyword"
              tabindex="21"
            />
          </div>
        </div>
      </Panel>
    </div>
  </div>
</template>

<script lang="ts">
// @ts-nocheck TODO: 既存の型エラーを解消したら外す
import { mapActions, mapState } from 'pinia'
import { defineComponent } from 'vue'

import ColorPicker from '@/client/components/_atoms/color_picker'
import EditableComponent from '@/client/components/_atoms/editable/editable.vue'
import ImageUpload from '@/client/components/_atoms/image_upload'
import Message from '@/client/components/_atoms/Message.vue'
import MessageConvert from '@/client/components/_atoms/message_convert'
import Panel from '@/client/components/_atoms/Panel.vue'
import TagInput from '@/client/components/_atoms/tag_input'
import Tips from '@/client/components/_atoms/Tips.vue'
import FormItemLabel from '@/client/components/_molecules/FormItemLabel.vue'
import Tags from '@/client/components/_molecules/Tags.vue'
import SectionList from '@/client/components/_organisms/section_list'
import {
  CAMPAIGN_APPLICATION_TYPES,
  CAMPAIGN_STATUS,
  CAMPAIGN_TYPES,
  TWITTER_ENTRY_ACTION_TYPES,
  WEB_INSTANTWIN_APPLICATION_TYPES,
  WEB_INSTANTWIN_MEDIA_MAIN_PAGE_ORIGIN_NAME
} from '@/client/constant'
import api from '@/client/core/api'
import TwitterUpload from '@/client/core/twitter_upload'
import { TrackingService } from '@/client/services'
import { useCampaignDialogStore } from '@/client/store/useCampaignDialogStore'
import { useSystemStore } from '@/client/store/useSystemStore'
import { validateKeywords } from '@/client/utils/validation'
import { isBeforeNttAaaSwitchover } from '@/common/utils'

const DEFAULT_FOOTER_TEXT_COLOR = '#333333'
const DEFAULT_BODY_BACKGROUND_COLOR = '#FFFFFF'
const DEFAULT_LOGO_HEADER_PC_HEIGHT = 64
const DEFAULT_LOGO_HEADER_SP_HEIGHT = 64

export default defineComponent({
  name: 'CampaignCreateTwitterCondition',
  components: {
    FormItemLabel,
    ColorPicker,
    ImageUpload,
    Message,
    Panel,
    Tips,
    Tags,
    TagInput,
    SectionList,
    MessageConvert,
    EditableComponent
  },
  data() {
    return {
      retweet_action_type: 'retweet',
      tweet_action_type: 'tweet',
      is_include_mention: true,
      is_include_reply: true,
      exclude_hunter_account: true,
      exclude_account_create_date_within_period: true,
      exclude_default_profile_image: true,
      exclude_no_description: true,
      exclude_unfollowed: true,
      min_followers: 0,
      min_tweets: 0,
      is_keyword_judgment: true,
      page_main_image_url: null as string | null,
      page_main_image_origin_name: null as string | null,
      upload_media_type_loading: null as 'main' | 'ogp' | 'logo' | null,
      is_logo_color_visible: false,
      is_footer_color_visible: false,
      is_change_page_title: false,
      is_change_page_text: false,
      is_change_page_rules: false,
      is_change_ogp_title: false,
      is_change_ogp_image: false,
      highlights: [
        {
          type: 'info',
          keywords: ['_account_name_', '_screen_name_', '_account_id_', '_serial_code_']
        }
      ],
      is_browser_guide_enabled: false,
      auth_error_guide_image_load_failed: false
    }
  },
  created() {
    if (!TWITTER_ENTRY_ACTION_TYPES.map(v => v.value).includes(this.form.entry_action_type)) {
      const form = {
        ...this.form,
        entry_action_type: 'retweet'
      }

      this.setForm(form)
    }

    this.is_include_mention = Boolean(this.form.is_include_mention)
    this.is_include_reply = Boolean(this.form.is_include_reply)
    this.exclude_hunter_account = Boolean(this.form.exclude_hunter_account)
    this.is_browser_guide_enabled = Boolean(this.form.is_browser_guide_enabled)
    this.exclude_account_create_date_within_period = Boolean(this.form.exclude_account_create_date_within_period)
    this.exclude_default_profile_image = Boolean(this.form.exclude_default_profile_image)
    this.exclude_no_description = Boolean(this.form.exclude_no_description)
    this.exclude_unfollowed = Boolean(this.form.exclude_unfollowed)
    this.min_followers = Number(this.form.min_followers)
    this.min_tweets = Number(this.form.min_tweets)
    this.is_keyword_judgment = Boolean(this.form.is_keyword_judgment)
    this.page_main_image_url = this.form.page_main_image_url || null
    this.page_main_image_origin_name =
      this.form.page_main_image_origin_name || WEB_INSTANTWIN_MEDIA_MAIN_PAGE_ORIGIN_NAME
    this.is_logo_color_visible = this.custom_layout.logo_background_color !== null
    this.is_footer_color_visible = this.custom_layout.footer_background_color !== null
  },
  computed: {
    ...mapState(useCampaignDialogStore, [
      'form',
      'mode',
      'api_campaign',
      'webiw_background_color_show_hex',
      'is_period_end_after_ntt_aaa_switchover',
      'is_web_instantwin_period_invalid',
      'ntt_aaa_switchover_date_text',
      'is_url_setting_notice_target',
      'is_keyword_input_hidden',
      'is_url_setting_notice_target',
      'is_long_post_notice_target'
    ]),
    ...mapState(useSystemStore, ['currentGroup', 'user']),
    auth_error_guide_image_src() {
      return require('@/client/assets/images/auth-error-guide.png')
    },
    application_type() {
      switch (this.form.entry_action_type) {
        case 'retweet':
        case 'quote_tweet':
        case 'retweet_and_quote_tweet':
          this.retweet_action_type = this.form.entry_action_type
          return 'retweet'
        case 'tweet':
        case 'tweet_media':
          this.tweet_action_type = this.form.entry_action_type
          return 'tweet'
        case 'mention':
          return 'mention'
        default:
          return 'retweet'
      }
    },
    /**
     * 応募条件に切替日時のエラーを表示するか。
     * 編集と複製はキャンペーンタイプを変更できないため、案内が操作に結びつく新規作成のみ対象とする。
     */
    is_web_instantwin_period_error() {
      return this.mode === 'create' && this.is_web_instantwin_period_invalid
    },
    campaign_type_options() {
      // 切替日時以降、および期間の終了日時が切替日時より後の場合は WEB インスタントウィンを新規作成できないため選択肢から除外.
      // 選択中はラベル表示を保つため選択肢に残し、通常キャンペーンへ変更したときに選択肢から消える.
      const is_web_instantwin_visible =
        this.currentGroup.allowWebInstantwin &&
        (this.is_web_instantwin_campaign ||
          (isBeforeNttAaaSwitchover() && !this.is_period_end_after_ntt_aaa_switchover))

      if (is_web_instantwin_visible) {
        return CAMPAIGN_TYPES
      }

      return CAMPAIGN_TYPES.filter(v => v.value !== 'old_web_instantwin')
    },
    application_type_options() {
      if (this.is_keyword_campaign) {
        return CAMPAIGN_APPLICATION_TYPES
      }

      return WEB_INSTANTWIN_APPLICATION_TYPES
    },
    layout_type() {
      return this.form.layout_type || 'basic'
    },
    is_basic_layout() {
      return this.layout_type === 'basic'
    },
    is_custom_layout() {
      return this.layout_type === 'custom'
    },
    is_keyword_campaign() {
      return this.form.campaign_type === 'keyword'
    },
    is_web_instantwin_campaign() {
      return this.form.campaign_type === 'old_web_instantwin'
    },
    is_retweet_campaign() {
      return this.application_type === 'retweet'
    },
    is_tweet_campaign() {
      return this.application_type === 'tweet'
    },
    is_mention_campaign() {
      return this.application_type === 'mention'
    },
    is_retweet_action() {
      return this.form.entry_action_type === 'retweet'
    },
    is_quote_tweet_action() {
      return this.form.entry_action_type === 'quote_tweet'
    },
    is_retweet_and_quote_tweet_action() {
      return this.form.entry_action_type === 'retweet_and_quote_tweet'
    },
    is_tweet_action() {
      return this.form.entry_action_type === 'tweet'
    },
    is_tweet_media_action() {
      return this.form.entry_action_type === 'tweet_media'
    },
    is_allow_instantwin() {
      return Boolean(this.currentGroup.allowInstantwin)
    },
    is_condition_disabled() {
      return (
        this.api_campaign &&
        [CAMPAIGN_STATUS.DURING_FINAL_COLLECTION, CAMPAIGN_STATUS.COLLECTION_COMPLETED].includes(
          this.api_campaign.status
        ) &&
        this.mode === 'edit'
      )
    },
    custom_layout() {
      const customLayout = this.form.custom_layout || {
        ogp_title: '',
        ogp_main_image_url: '',
        ogp_main_image_origin_name: '',
        logo_image_url: null,
        logo_image_origin_name: null,
        logo_url: null,
        logo_background_color: null,
        logo_is_enabled: false,
        logo_header_pc_height: DEFAULT_LOGO_HEADER_PC_HEIGHT,
        logo_header_sp_height: DEFAULT_LOGO_HEADER_SP_HEIGHT,
        body_background_color: DEFAULT_BODY_BACKGROUND_COLOR,
        footer_title: '',
        footer_background_color: null,
        footer_text: DEFAULT_FOOTER_TEXT_COLOR,
        sections: []
      }

      return {
        ...customLayout,
        sections: customLayout.sections || []
      }
    },
    logo_header_pc_height_input() {
      return this.custom_layout.logo_header_pc_height ? String(this.custom_layout.logo_header_pc_height) : ''
    },
    logo_header_sp_height_input() {
      return this.custom_layout.logo_header_sp_height ? String(this.custom_layout.logo_header_sp_height) : ''
    },
    is_logo_color_enabled() {
      return this.is_logo_color_visible
    },
    footer_background_color_display() {
      return this.custom_layout.footer_background_color ?? ''
    },
    is_footer_color_enabled() {
      return this.is_footer_color_visible
    },
    custom_sections() {
      return [...this.custom_layout.sections].sort((a, b) => a.step_order - b.step_order)
    },
    is_title_empty() {
      return this.is_change_page_title && !this.form.page_title.trim()
    },
    is_title_max_length() {
      return !!this.form.page_title.trim() && this.form.page_title.trim().length > 50
    },
    is_page_text_empty() {
      return this.is_change_page_text && !this.form.page_text.trim()
    },
    is_page_rules_empty() {
      return this.is_change_page_rules && !this.form.page_rules.trim()
    },
    is_ogp_title_empty() {
      return this.is_change_ogp_title && !this.custom_layout.ogp_title.trim()
    },
    is_ogp_image_empty() {
      return this.is_change_ogp_image && !this.custom_layout.ogp_main_image_url
    },
    is_logo_url_invalid() {
      return Boolean(this.custom_layout.logo_url) && !this.isValidHttpUrl(this.custom_layout.logo_url)
    },
    positive_keyword() {
      return this.form.positive_keyword ? this.form.positive_keyword : []
    },
    negative_keyword() {
      return this.form.negative_keyword ? this.form.negative_keyword : []
    },
    and_keywords() {
      return this.form.keywords
    },
    or_keywords() {
      return this.form.or_keywords ? this.form.or_keywords : []
    },
    combinations() {
      if (!this.form.keywords.length && (!this.form.or_keywords || !this.form.or_keywords.length)) {
        return []
      }

      return this.form.or_keywords && this.form.or_keywords.length
        ? this.form.or_keywords.map(or_keyword => [...this.form.keywords, or_keyword])
        : [this.form.keywords]
    }
  },
  methods: {
    ...mapActions(useCampaignDialogStore, ['setForm']),
    isValidHttpUrl(url?: string | null) {
      if (!url) {
        return true
      }
      return /^https?:\/\//.test(url)
    },
    cancel(payload: unknown) {
      this.$emit('cancel', payload)
      return payload
    },
    /**
     * 変化
     */
    change(type: string) {
      switch (type) {
        case 'page_title':
          this.is_change_page_title = true
          break
        case 'page_text':
          this.is_change_page_text = true
          break
        case 'page_rules':
          this.is_change_page_rules = true
          break
        case 'ogp_title':
          this.is_change_ogp_title = true
          break
        case 'ogp_image':
          this.is_change_ogp_image = true
          break
        default:
          break
      }
    },
    /**
     * ページタイトルを設定
     */
    async setPageTitle(value: string) {
      TrackingService.sendEvent('input:キャンペーンの新規作成|応募条件(X)|ページタイトル')

      this.change('page_title')

      await this.setForm({ ...this.form, page_title: value })
    },
    /**
     * ページテ規約を設定
     */
    async setPageRules(value: string) {
      TrackingService.sendEvent('input:キャンペーンの新規作成|応募条件(X)|規約')

      this.change('page_rules')

      await this.setForm({ ...this.form, page_rules: value })
    },
    /**
     * ページテキストを設定
     */
    async setPageText(value: string) {
      TrackingService.sendEvent('input:キャンペーンの新規作成|応募条件(X)|ページテキスト')

      this.change('page_text')

      await this.setForm({ ...this.form, page_text: value })
    },
    /**
     * レイアウト種別を設定
     */
    async setLayoutType(layout_type: 'basic' | 'custom') {
      const form = {
        ...this.form,
        layout_type
      }

      await this.setForm(form)
    },
    /**
     * OGPタイトルを設定
     */
    async setOgpTitle(value: string) {
      this.change('ogp_title')
      await this.updateCustomLayout({ ogp_title: value })
    },
    /**
     * OGP画像を削除
     */
    async removeOgpMedia() {
      this.change('ogp_image')
      await this.updateCustomLayout({
        ogp_main_image_url: '',
        ogp_main_image_origin_name: ''
      })
    },
    /**
     * ロゴ画像を削除
     */
    async removeLogoMedia() {
      await this.updateCustomLayout({
        logo_image_url: null,
        logo_image_origin_name: null
      })
    },
    /**
     * ロゴURLを設定
     */
    async setLogoUrl(value: string) {
      await this.updateCustomLayout({ logo_url: value })
    },

    parseHeaderHeightInput(value: string) {
      if (typeof value !== 'string') {
        return 0
      }
      const trimmed = value.trim()
      if (!trimmed) {
        return 0
      }
      if (!/^[0-9]+$/.test(trimmed)) {
        return 0
      }
      return Number(trimmed.slice(0, 3))
    },
    /**
     * ロゴヘッダー高さ（PC）を設定
     */
    async setLogoHeaderPcHeight(value: string) {
      await this.updateCustomLayout({ logo_header_pc_height: this.parseHeaderHeightInput(value) })
    },
    /**
     * ロゴヘッダー高さ（SP）を設定
     */
    async setLogoHeaderSpHeight(value: string) {
      await this.updateCustomLayout({ logo_header_sp_height: this.parseHeaderHeightInput(value) })
    },
    /**
     * ロゴ背景色のON/OFF
     */
    async toggleLogoColor(value: boolean) {
      this.is_logo_color_visible = value
      await this.updateCustomLayout({
        logo_background_color: value ? this.custom_layout.body_background_color : null
      })
    },

    /**
     * ロゴ背景色を設定
     */
    async setLogoBackgroundColor(value: string) {
      this.is_logo_color_visible = Boolean(value)
      await this.updateCustomLayout({ logo_background_color: value })
    },
    /**
     * フッターヘッダー文言を設定
     */
    async setFooterTitle(value: string) {
      await this.updateCustomLayout({ footer_title: value })
    },
    /**
     * フッター色設定のON/OFF
     */
    async toggleFooterColor(value: boolean) {
      this.is_footer_color_visible = value
      await this.updateCustomLayout({
        footer_background_color: value ? this.custom_layout.body_background_color : null
      })
    },
    /**
     * フッターテキスト色を設定
     */
    async setFooterTextColor(value: string) {
      await this.updateCustomLayout({ footer_text: value })
    },
    /**
     * フッター背景色を設定
     */
    async setFooterBackgroundColor(value: string) {
      this.is_footer_color_visible = Boolean(value)
      await this.updateCustomLayout({ footer_background_color: value })
    },
    /**
     * 全体背景色を設定
     */
    async setBodyBackgroundColor(value: string) {
      await this.updateCustomLayout({ body_background_color: value || DEFAULT_BODY_BACKGROUND_COLOR })
    },
    /**
     * セクション更新
     */
    async updateCustomSections(sections: any[]) {
      await this.updateCustomLayout({ sections })
    },
    /**
     * メディアアップロード共通処理
     */
    async uploadMediaFile(file: File) {
      const validFormat = ['video/mp4', 'image/jpeg', 'image/png', 'image/gif', 'image/pjpeg', 'image/gif']
      const checkValidMedia = await TwitterUpload.checkValidMedia(file, validFormat)

      if (checkValidMedia.error) {
        const error = checkValidMedia.error

        let title = ''
        let message = ''

        switch (error) {
          case 'INVALID_MEDIA':
            title = this.$gettext('Please upload valid format!')
            message = validFormat.join(', ')
            break
          case 'MAX_SIZE_VIDEO':
            title = this.$gettext(
              '25MB以上のビデオを利用することはできません。 サイズを調整してからアップロードしてください。'
            )
            break
          case 'MAX_SIZE_IMAGE':
            title = this.$gettext(
              '5MB以上の画像を利用することはできません。サイズを調整してからアップロードしてください。'
            )
            break
          case 'INVALID_DIMENSION':
            title = this.$gettext('画像・動画アップロードに失敗しました。')
            message = this.$gettext(
              '詳しくは<a target="_blank" href="https://help-atelu.comnico.jp/available-image-and-video">こちら</a>をご確認ください。'
            )
            break
        }

        this.showError(title, message)
        return null
      }

      const formData = new FormData()
      formData.append('file', file)

      const data = await api.post('/media_uploads', formData, {
        headers: {
          'Content-Type': undefined
        }
      })

      if (!data || !data.data || !data.data.media_url) {
        this.showError(this.$gettext('画像・動画アップロードに失敗しました。'), '')
        return null
      }

      return {
        url: data.data.media_url as string,
        origin_name: file.name
      }
    },
    /**
     * OGP画像をアップロード
     */
    async handleOgpFileChange(event: Event) {
      const target = event.target as HTMLInputElement
      if (!target.files || !target.files[0]) {
        return
      }

      this.upload_media_type_loading = 'ogp'
      this.change('ogp_image')

      const result = await this.uploadMediaFile(target.files[0])

      this.upload_media_type_loading = null

      if (!result) {
        return
      }

      await this.updateCustomLayout({
        ogp_main_image_url: result.url,
        ogp_main_image_origin_name: result.origin_name
      })
    },
    /**
     * ロゴ画像をアップロード
     */
    async handleLogoFileChange(event: Event) {
      const target = event.target as HTMLInputElement
      if (!target.files || !target.files[0]) {
        return
      }

      this.upload_media_type_loading = 'logo'

      const result = await this.uploadMediaFile(target.files[0])

      this.upload_media_type_loading = null

      if (!result) {
        return
      }

      await this.updateCustomLayout({
        logo_image_url: result.url,
        logo_image_origin_name: result.origin_name
      })
    },
    /**
     * セクションメディアアップロード
     */
    async handleSectionMediaChange(payload: { index: number; field: 'pc' | 'sp'; file: File }) {
      const result = await this.uploadMediaFile(payload.file)
      if (!result) {
        return
      }

      const sections = this.custom_sections.map(section => ({ ...section }))
      const target = sections[payload.index]

      if (!target || target.mode !== 'media') {
        return
      }

      if (payload.field === 'pc') {
        target.pc_media_url = result.url
        target.pc_media_name = result.origin_name
      } else {
        target.sp_media_url = result.url
        target.sp_media_name = result.origin_name
      }

      sections.splice(payload.index, 1, target)

      await this.updateCustomLayout({ sections })
    },
    /**
     * セクションメディア削除
     */
    async handleSectionMediaRemove(payload: { index: number; field: 'pc' | 'sp' }) {
      const sections = this.custom_sections.map(section => ({ ...section }))
      const target = sections[payload.index]

      if (!target || target.mode !== 'media') {
        return
      }

      if (payload.field === 'pc') {
        target.pc_media_url = null
        target.pc_media_name = null
      } else {
        target.sp_media_url = null
        target.sp_media_name = null
      }

      sections.splice(payload.index, 1, target)
      await this.updateCustomLayout({ sections })
    },
    /**
     * カスタムレイアウトを更新
     */
    async updateCustomLayout(patch: Record<string, any>) {
      const custom_layout = {
        ...this.custom_layout,
        ...patch
      }

      await this.setForm({ ...this.form, custom_layout })
    },
    /**
     * 実施アカウントを未フォローの場合、落選にするフラグを更新する
     */
    async changeExcludeUnfollowed(value: boolean) {
      TrackingService.sendEvent('switch:キャンペーンの新規作成|応募条件(X)|未フォローアカウント落選')

      const form = {
        ...this.form,
        exclude_unfollowed: value
      }

      await this.setForm(form)
    },
    /**
     * 認証エラーガイド画像表示フラグを更新する
     */
    async changeIsBrowserGuideEnabled(value: boolean) {
      TrackingService.sendEvent('switch:キャンペーンの新規作成|応募条件(X)|認証エラーガイド画像表示')

      const form = {
        ...this.form,
        is_browser_guide_enabled: value
      }

      await this.setForm(form)

      if (value) {
        this.auth_error_guide_image_load_failed = false
      }
    },
    /**
     * 懸賞アカウントの場合、落選にするフラグを更新する
     */
    async changeExcludeHunterAccount(value: boolean) {
      TrackingService.sendEvent('switch:キャンペーンの新規作成|応募条件(X)|懸賞アカウント落選')

      const form = {
        ...this.form,
        exclude_hunter_account: value
      }

      await this.setForm(form)
    },
    /**
     * アカウント開設日がキャンペーン期間内の場合、落選にするフラグを更新する
     */
    async changeExcludeAccountCreateDateWithinPeriod(value: boolean) {
      TrackingService.sendEvent('switch:キャンペーンの新規作成|応募条件(X)|アカウント開設日落選')

      const form = {
        ...this.form,
        exclude_account_create_date_within_period: value
      }

      await this.setForm(form)
    },
    /**
     * プロフィール画像が初期状態の場合、落選にするフラグを更新する
     */
    async changeExcludeDefaultProfileImage(value: boolean) {
      TrackingService.sendEvent('switch:キャンペーンの新規作成|応募条件(X)|プロフィール画像が初期')

      const form = {
        ...this.form,
        exclude_default_profile_image: value
      }

      await this.setForm(form)
    },
    /**
     * 自己紹介が未入力の場合、落選にするフラグを更新する
     */
    async changeExcludeNoDescription(value: boolean) {
      TrackingService.sendEvent('switch:キャンペーンの新規作成|応募条件(X)|未入力落選')

      const form = {
        ...this.form,
        exclude_no_description: value
      }

      await this.setForm(form)
    },
    /**
     * フォロワー数が指定値未満の場合、落選にするフラグを更新する
     */
    async onChangeMinFollowers(value: number) {
      if (value === this.form.min_followers + 1) {
        TrackingService.sendEvent('click:キャンペーンの新規作成|応募条件(X)|フォロワー指定値|UP')
      } else if (value === this.form.min_followers - 1) {
        TrackingService.sendEvent('click:キャンペーンの新規作成|応募条件(X)|フォロワー指定値|DOWN')
      } else TrackingService.sendEvent('input:キャンペーンの新規作成|応募条件(X)|フォロワー指定値')

      const form = {
        ...this.form,
        min_followers: value
      }

      await this.setForm(form)
    },
    /**
     * ポスト数が指定値未満の場合、落選にするフラグを更新する
     */
    async onChangeMinTweets(value: number) {
      if (value === this.form.min_tweets + 1) {
        TrackingService.sendEvent('click:キャンペーンの新規作成|応募条件(X)|ポスト指定値|UP')
      } else if (value === this.form.min_tweets - 1) {
        TrackingService.sendEvent('click:キャンペーンの新規作成|応募条件(X)|ポスト指定値|DOWN')
      } else TrackingService.sendEvent('input:キャンペーンの新規作成|応募条件(X)|ポスト指定値')

      const form = {
        ...this.form,
        min_tweets: value
      }

      await this.setForm(form)
    },
    /**
     * エラーを表示
     * @param {string} title
     * @param {string} message
     */
    showError(title: string, message: string) {
      this.$notify({
        title,
        message,
        customClass: 'danger',
        dangerouslyUseHTMLString: true,
        duration: 5000
      })
    },
    /**
     * キャンペーンタイプを選択する
     */
    async changeCampaignType(campaign_type: string) {
      TrackingService.sendEvent('select:キャンペーンの新規作成|応募条件(X)|キャンペーンタイプ')

      let form = {
        ...this.form,
        campaign_type
      }

      if (campaign_type === 'old_web_instantwin') {
        form = {
          ...form,
          entry_action_type: this.retweet_action_type,
          layout_type: this.layout_type || 'basic',
          custom_layout: this.form.custom_layout || this.custom_layout
        }
      }

      await this.setForm(form)
    },
    /**
     * 応募アクションを選択する
     */
    async changeApplicationType(application_type: string) {
      TrackingService.sendEvent('select:キャンペーンの新規作成|応募条件(X)|応募条件')

      let entry_action_type = application_type
      if (application_type === 'retweet') {
        entry_action_type = this.retweet_action_type
      } else if (application_type === 'tweet') {
        entry_action_type = this.tweet_action_type
      }

      const form = {
        ...this.form,
        entry_action_type
      }

      await this.setForm(form)
    },
    /**
     * 応募条件を選択する
     */
    async changeActionType(value: string) {
      switch (value) {
        case 'retweet':
          TrackingService.sendEvent('radio:キャンペーンの新規作成|応募条件(X)|公式リポスト')
          break
        case 'quote_tweet':
          TrackingService.sendEvent('radio:キャンペーンの新規作成|応募条件(X)|引用')
          break
        case 'retweet_and_quote_tweet':
          TrackingService.sendEvent('radio:キャンペーンの新規作成|応募条件(X)|全て')
          break
        case 'tweet':
          TrackingService.sendEvent('radio:キャンペーンの新規作成|応募条件(X)|通常')
          break
        case 'tweet_media':
          TrackingService.sendEvent('radio:キャンペーンの新規作成|応募条件(X)|画像または動画')
          break
        default:
          break
      }

      const form = {
        ...this.form,
        entry_action_type: value
      }

      await this.setForm(form)
    },
    /**
     * 説明キーワードを除外
     * @param {string[]} keywords
     */
    async onChangeExcludeDescriptionKeyword(keywords: string[]) {
      const uniqueKeywords = Array.from(
        new Set(
          keywords.flatMap(v =>
            v
              .split(',')
              .map(v => v.trim())
              .filter(Boolean)
          )
        )
      )

      const form = {
        ...this.form,
        exclude_description_keyword: uniqueKeywords
      }

      await this.setForm(form)
    },
    /**
     * メンションを含めるフラグを更新する
     */
    async changeIsIncludeMention(value: boolean) {
      const form = {
        ...this.form,
        is_include_mention: value
      }

      await this.setForm(form)
    },
    /**
     * 返信を含めるフラグを更新する
     */
    async changeIsIncludeReply(value: boolean) {
      const form = {
        ...this.form,
        is_include_reply: value
      }

      await this.setForm(form)
    },
    /**
     * キーワード判定フラグを更新する
     */
    async changeIsKeywordJudgment(value: boolean) {
      TrackingService.sendEvent('click:キャンペーンの新規作成|応募条件(X)|アカウントを判定する')

      const form = {
        ...this.form,
        is_keyword_judgment: value
      }

      await this.setForm(form)
    },
    /**
     * ポジティブキーワードを更新する
     */
    async changePositiveKeywords(value: string[]) {
      if ((this.form.positive_keyword?.length ?? 0) < value.length) {
        TrackingService.sendEvent('click:キャンペーンの新規作成|応募条件(X)|ポジティブキーワード|追加')
      } else TrackingService.sendEvent('click:キャンペーンの新規作成|応募条件(X)|ポジティブキーワード|削除')

      const form = {
        ...this.form,
        positive_keyword: value
      }

      await this.setForm(form)
    },
    /**
     * ネガティブキーワードを更新する
     */
    async changeNegativeKeywords(value: string[]) {
      if ((this.form.negative_keyword?.length ?? 0) < value.length) {
        TrackingService.sendEvent('click:キャンペーンの新規作成|応募条件(X)|ネガティブキーワード|追加')
      } else TrackingService.sendEvent('click:キャンペーンの新規作成|応募条件(X)|ネガティブキーワード|削除')

      const form = {
        ...this.form,
        negative_keyword: value
      }

      await this.setForm(form)
    },
    /**
     * ANDキーワードを更新する
     */
    async changeAndKeywords(keywords: string[]) {
      if ((this.form.or_keywords?.length ?? 0) < keywords.length) {
        TrackingService.sendEvent('click:キャンペーンの新規作成|応募条件(X)|全てを含む|追加')
      } else TrackingService.sendEvent('click:キャンペーンの新規作成|応募条件(X)|全てを含む|削除')

      const validationResult = validateKeywords(keywords, this.form.keywords || [])

      if (!validationResult.isValid) {
        this.showError(validationResult.errorMessage || 'キーワードに利用できない文字列が含まれています。', '')
        return
      }

      if (keywords.length > 0) {
        const is_duplicate = this.form.or_keywords && this.form.or_keywords.includes(keywords[keywords.length - 1])

        if (is_duplicate) {
          this.showError('すでに登録済みのキーワードです。', '')
          return
        }
      }

      const form = {
        ...this.form,
        keywords: keywords
      }

      await this.setForm(form)
    },
    /**
     * ORキーワードを更新する
     */
    async changeOrKeywords(or_keywords: string[]) {
      if ((this.form.or_keywords?.length ?? 0) < or_keywords.length) {
        TrackingService.sendEvent('click:キャンペーンの新規作成|応募条件(X)|いずれかを含む|追加')
      } else TrackingService.sendEvent('click:キャンペーンの新規作成|応募条件(X)|いずれかを含む|削除')

      const validationResult = validateKeywords(or_keywords, this.form.or_keywords || [])

      if (!validationResult.isValid) {
        this.showError(validationResult.errorMessage || 'キーワードに利用できない文字列が含まれています。', '')
        return
      }

      if (or_keywords.length > 0) {
        const is_duplicate = this.form.keywords.includes(or_keywords[or_keywords.length - 1])

        if (is_duplicate) {
          this.showError('すでに登録済みのキーワードです。', '')
          return
        }
      }

      const form = {
        ...this.form,
        or_keywords: or_keywords
      }

      await this.setForm(form)
    },
    /**
     * メディアファイル削除
     */
    async removeMedia() {
      this.page_main_image_url = null
      this.page_main_image_origin_name = null

      const remove_data = {
        ...this.form,
        page_main_image_url: null,
        page_main_image_origin_name: null
      }

      await this.setForm(remove_data)
    },
    /**
     * ファイルを変更
     */
    async handleFileChange(e: Event) {
      TrackingService.sendEvent('click:キャンペーンの新規作成|応募条件(X)|アップロード')

      const target = e.target as HTMLInputElement
      if (!target.files || !target.files[0]) {
        return
      }

      this.upload_media_type_loading = 'main'

      const result = await this.uploadMediaFile(target.files[0])

      this.upload_media_type_loading = null

      if (!result) {
        return
      }

      this.page_main_image_url = result.url
      this.page_main_image_origin_name = result.origin_name

      const upload_data = {
        ...this.form,
        page_main_image_url: this.page_main_image_url,
        page_main_image_origin_name: this.page_main_image_origin_name
      }

      await this.setForm(upload_data)
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'sass:math';
@use '@/client/assets/scss/variables.scss' as *;

.campaign-create-condition {
  margin-top: $spacing-unit * 2;
}

.campaign-action-type {
  margin-top: $spacing-unit;
}

.condition-description {
  margin-top: $spacing-unit;
  font-size: 12px;
  color: $sub-text-color;
}

.condition-sub-description {
  margin-top: math.div($spacing-unit, 2);
  font-size: 12px;
  color: $sub-text-color;
}

.condition-tips {
  margin-top: $spacing-unit;
  white-space: nowrap;
}

.condition-image {
  margin-top: $spacing-unit;

  img {
    width: 100%;
  }
}

.condition-item:not(:first-child) {
  margin-top: $spacing-unit * 2;
}

// グローバルデザインだと崩れるため、display: inline-block に変更
.badge.badge-danger {
  position: initial;
  display: inline-block;
}

.panel-section {
  display: flex;
  flex-direction: column;
  gap: $spacing-unit;
}

.condition-keywords {
  margin-top: $spacing-unit;
}

.webiw-px-label {
  display: flex;
  align-items: center;
  justify-content: center;
  width: $spacing-unit * 4;
  height: 100%;
}

.description-danger {
  margin-top: $spacing-unit;
  font-size: 12px;
  color: $danger-color;
}

.description-combination {
  font-size: 12px;
  color: $sub-text-color;
}

.condition-combination-keyword {
  display: flex;
  align-items: center;
  margin-top: $spacing-unit;
}

.condition-combination-index {
  margin: 0 $spacing-unit $spacing-unit 0;
}

.web-instanwin-page .input-container {
  display: flex;
  margin-top: $spacing-unit * 2;
}

.webiw-label-row {
  display: inline-flex;
  flex-wrap: wrap;
  gap: $spacing-unit;
  align-items: center;
  max-width: 100%;
}

.webiw-label-row .badge.badge-danger,
.webiw-label-row .mdi-help-circle {
  margin-left: 0;
}

.web-instanwin-page-select {
  width: 100%;
}

.web-instanwin-page-media {
  width: 100%;
}

.media-limit-text {
  display: block;
  margin-top: $spacing-unit;
}

.media-preview {
  position: relative;
  display: inline-block;
  padding: math.div($spacing-unit, 2) $spacing-unit;
  border: 1px solid $border-color;
  border-radius: $round;

  .media-name {
    padding-right: $spacing-unit * 3;
  }

  .mdi {
    position: absolute;
    top: math.div($spacing-unit, 2);
    right: math.div($spacing-unit, 2);
    cursor: pointer;
  }
}

.direct-media {
  max-width: 100%;
  max-height: $spacing-unit * 32;
}

.title-input-error {
  margin-top: $spacing-unit;
  color: $danger-color;
}

.webiw-input-error-field:deep(.el-input__inner) {
  border-color: $danger-color;
}

.webiw-input-error-field:deep(.el-input__inner:focus) {
  border-color: $danger-color;
}

.error-container {
  display: flex;
}

.empty-label {
  flex: 30%;
}

.mdi-help-circle {
  margin-left: $spacing-unit;
  font-size: 18px;
}

.footer-label {
  display: flex;
  gap: $spacing-unit;
}

.web-instantwin-win-textarea {
  width: 100%;
  height: 100%;
}

.web-instantwin-action-type {
  .el-select {
    width: 65%;
  }
}

.logo-color-label {
  width: 100%;
}

.footer-title-input {
  box-sizing: border-box;
  flex: 1;
  width: 100%;
  min-height: 40px;
  padding: 8px 12px;
  font-size: $font-size;
  line-height: 1.4;
  resize: vertical;
  border: 1px solid $border-color;
  border-radius: $round;

  &:disabled {
    background-color: rgba($background-color, 0.6);
  }
}

.auth-error-guide-row {
  display: flex;
  flex-direction: column;
  gap: $spacing-unit * 2;
  align-items: flex-start;
}

.auth-error-guide-label {
  display: flex;
  gap: $spacing-unit;
  align-items: center;
}

.auth-error-guide-preview {
  display: inline-block;
  flex-direction: column;
  gap: $spacing-unit;
  margin-top: $spacing-unit * 2;
}

.auth-error-guide-preview-frame {
  display: block;
  width: 50%;
}

.auth-error-guide-preview-image {
  display: block;
  width: 100%;
  height: auto;
}

.auth-error-guide-fallback {
  padding: $spacing-unit * 4;
  color: $sub-text-color;
  text-align: center;
}
</style>
